const styles = {
  width: '200px',
  marginTop: '14px'
}

export default styles



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingsCalendar/BookingPopover/styles/manualTimeCheckbox.js